
import React from 'react';
import { Briefcase, MapPin, DollarSign } from 'lucide-react';

interface ReviewDetailsProps {
  jobTitle?: string;
  location: string;
  salary?: number;
}

// Helper function to format salary with a thousands separator
const formatSalary = (salary: number | undefined) => {
  if (!salary) return '';
  
  return new Intl.NumberFormat('en-AU', { 
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(salary) + ' + Super';
};

const ReviewDetails = ({ jobTitle, location, salary }: ReviewDetailsProps) => {
  return (
    <div className="flex flex-col gap-4">
      {jobTitle && (
        <div className="flex items-start gap-2">
          <Briefcase className="w-4 h-4 text-redflags-gray mt-0.5 shrink-0" />
          <div>
            <p className="text-sm text-redflags-gray">Job Title</p>
            <p className="text-redflags-dark">{jobTitle}</p>
          </div>
        </div>
      )}
      
      <div className="flex items-start gap-2">
        <MapPin className="w-4 h-4 text-redflags-gray mt-0.5 shrink-0" />
        <div>
          <p className="text-sm text-redflags-gray">Location</p>
          <p className="text-redflags-dark">{location}</p>
        </div>
      </div>
      
      {salary && (
        <div className="flex items-start gap-2">
          <DollarSign className="w-4 h-4 text-redflags-gray mt-0.5 shrink-0" />
          <div>
            <p className="text-sm text-redflags-gray">Salary</p>
            <p className="text-redflags-dark">{formatSalary(salary)}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewDetails;
